export enum ACTIVITY_FEED_CONTENT_TYPE {
  TEXT = 'text',
  MENTION = 'mention',
}

export enum ACTIVITY_FEED_MODULE {
  FEEDBACK = 'feedback',
  HEATMAPS = 'heatmaps',
  POLLS = 'polls',
  SURVEYS = 'surveys',
  RECORDINGS = 'recordings',
  SEGMENTS = 'segments',
  SYSTEM = 'system',
}

export interface ActivityFeedEventContent {
  type: ACTIVITY_FEED_CONTENT_TYPE;
  value: string;
  uuid: string;
}

export interface ActivityFeedEvent {
  id: number;
  action: string;
  module: ACTIVITY_FEED_MODULE | string;
  created: number;
  description?: string;
  linkText?: string;
  linkUrl?: string;
  username?: string;
  pictureUrl?: string;
  content: ActivityFeedEventContent[] | null;
  trackingUIPosition?: string;
}
